import XTbl, {Xtc} from '@/components/new-x-table/index';

const tbl = new XTbl('/work', 'لیست پرسنل');
tbl.add(new Xtc('name', 'نام و نام خانوادگی').filterText())
tbl.add(new Xtc('ncode', 'کد ملی').filterText())
tbl.add(new Xtc('count_year', 'سابقه کار').renderSlot('count_year'))
tbl.add(new Xtc('last_education_str', 'آخرین مدرک تحصیلی').filterText())
export default tbl;
